export enum AddressErrorsList {
  addressAlreadyExist = 'addressAlreadyExist',
  addressNotFound = 'addressNotFound',
  addressNotFull = 'addressNotFull',
  addressIsRequired = 'addressIsRequired',
  addressIsLong = 'addressIsLong',
  notServedTerritory = 'notServedTerritory',
}

export enum AddressErrorsType {
  addressAlreadyExist = 'Такой адрес уже есть в списке',
  addressNotFound = `Не удалось найти адрес. Проверьте написание или укажите только город и 
  улицу — без номера дома и квартиры.`,
  addressNotFull = 'Выберите полный адрес',
  addressIsRequired = 'Обязательно для заполнения',
  addressIsLong = 'Введен слишком длинный адрес',
  notServedTerritory = 'Данный адрес не обслуживается',
}
